import { getUploadOutcomeMessage } from '../../Services/candidateFileUpload';

export const getSingleDocumentUploadFailureDialog = ({ clientOperationId, isReconciliationRequired, replacementStatus }) => {
  const isRetryAllowed = Boolean(clientOperationId) && !isReconciliationRequired;

  return {
    isRetryAllowed,
    message: isReconciliationRequired
      ? 'The upload status could not be confirmed. Refresh the document list before trying again.'
      : getUploadOutcomeMessage({ isProfilePhoto: false, replacementStatus }),
  };
};
